<template>
  <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="field-label title_text">
      {{ question.num }}、<span v-html="question.title"></span>
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="ui-input-text">
      <input type="text" v-model="otherWords"/>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      otherWords: ''
    }
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null && question.answer !== '') {
      this.otherWords = question.answer
      question.errorMessage = ''
    }
  },
  watch: {
    otherWords: function (newVal, oldVal) {
      if (newVal !== '') {
        this.question.finish = 1
        this.question.errorMessage = ''
      } else {
        this.question.finish = 0
      }
      this.question.answer = newVal
      this.$emit("listenToChildEvent", this.question.num, this.otherWords, this.question);
    }
  }
}
</script>
<style scoped>
.ui-input-text {
  border: 1px solid #d5d5d5;
  margin: 5px 0;
  background-color: #fff;
  padding: 0;
  border-radius: 3px;
}

.ui-input-text input {
  width: 96%;
  background-color: #fff;
  border: none !important;
  border-radius: 5px;
  padding: 8px 10px;
  font-size: 16px;
  display: inline-block;
  margin: 0;
  -webkit-appearance: none;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
